import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { RecipientRepository } from '../../domain/recipient/recipient-repository';
import {
  RecipientCreateRequest,
  RecipientCreateResponse
} from '../../domain/recipient/recipient-domain';
import { ApiUrlsService } from '@shared/constants/urls.contants';

@Injectable()
export class RecipientHttpRepository extends RecipientRepository {
  private readonly http = inject(HttpClient);
  private readonly urls = inject(ApiUrlsService);

  async createRecipient(data: RecipientCreateRequest): Promise<RecipientCreateResponse> {
    return firstValueFrom(
      this.http.post<RecipientCreateResponse>(this.urls.CREATE_RECIPIENT_URL, data)
    );
  }
}
